import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const TopicEditModel = types
  .model("TopicEditModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("EDITING_TOPIC_DATA");
    },
    set(response) {
      let status = response.data.response;
      let data;
      if (status === "SUCCESS") {
        data = `The topic has been edited successfully.`;
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res:"Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default TopicEditModel;
